export default "__VITE_ASSET__C5EnE2_d__"